"use strict";

class PropertySelectionController {

    constructor($scope, $window, $cookies, $localStorage, $sce, SSHttpService, SSUtilService, SSAlertService, SSConfigService, SSUserService, OTPService, $timeout, SSAwsService, SSAppService, Upload) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$cookies = $cookies;
        self.$timeout = $timeout;
        self.$localStorage = $localStorage;
        self.sce = $sce;
        self.Upload = Upload;


        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSAwsService = SSAwsService;
        self.SSAppService = SSAppService;

        self.data = SHOWSUITE.data;
        self.property = SHOWSUITE.data.property;
        self.property_id = SHOWSUITE.data.property_id;

        self.QUESTION_TYPE_YES_NO = SHOWSUITE.QUESTION_TYPE_YES_NO;
        self.QUESTION_TYPE_YES_NO_NA = SHOWSUITE.QUESTION_TYPE_YES_NO_NA;
        self.QUESTION_TYPE_TEXT = SHOWSUITE.QUESTION_TYPE_TEXT;
        self.QUESTION_TYPE_NUMBER = SHOWSUITE.QUESTION_TYPE_NUMBER;
        self.QUESTION_TYPE_SELECT = SHOWSUITE.QUESTION_TYPE_SELECT;
        self.QUESTION_TYPE_CHECKBOX = SHOWSUITE.QUESTION_TYPE_CHECKBOX;
        self.QUESTION_TYPE_RADIO = SHOWSUITE.QUESTION_TYPE_RADIO;

        /*
        * Selection groups
        */
        self.QUESTION_GROUP_INDIVIDUAL = SHOWSUITE.QUESTION_GROUP_INDIVIDUAL   //  10;
        self.QUESTION_GROUP_COMPANY = SHOWSUITE.QUESTION_GROUP_COMPANY  //  20;

        self.UNIT_CATEGORIES_MAP = {
            0: {code: 'XX', name: 'Other', className: 'empty'},
            1: {code: '1BR', name: '1 Bedroom', className: 'bed1'},
            2: {code: '2BR', name: '2 Bedroom', className: 'bed2'},
            3: {code: '3BR', name: '3 Bedroom', className: 'bed3'},
            4: {code: '4BR', name: '4 Bedroom', className: 'bed4'},
            5: {code: '5BR', name: '5 Bedroom', className: 'bed5'},
            6: {code: 'PH', name: 'Penthouse', className: 'ph'},
            7: {code: 'COM', name: 'Commercial', className: 'retail'},
            1000: {code: 'CT', name: 'Corner Terrace', className: 'corner-terrace'},
            2000: {code: 'IT', name: 'Intermediate Terrace', className: 'interlaced-terrace'},
            3000: {code: 'SD', name: 'Semi-Detached', className: 'semi-detached'},
            4000: {code: 'DE', name: 'Detached', className: 'detached'},
            4001: {code: 'SU', name: 'Storage Unit', className: 'retail'},
            4002: {code: 'WH', name: 'Warehouse', className: 'detached'},
        };

        // UNIT_STATUS_DRAFT = 10; // just created not listed
        // UNIT_STATUS_LISTED = 20; // listing and ready for sale to public
        // UNIT_STATUS_RESERVED = 30; // booknow session in-progress
        // UNIT_STATUS_BOOKED = 40; // dealing in process
        // UNIT_STATUS_SOLD = 50;
        // UNIT_STATUS_SPECIAL_RESERVED = 60;// Long time reserved

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.PROPERTY_SETTINGS_SELECTIONS = SHOWSUITE.PROPERTY_SETTINGS_SELECTIONS;
        self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER;

        self.PROPERTY_DOCUMENT_PHASE_EOI = SHOWSUITE.PROPERTY_DOCUMENT_PHASE_EOI;
        self.PROPERTY_DOCUMENT_PHASE_BOOKING = SHOWSUITE.PROPERTY_DOCUMENT_PHASE_BOOKING;
        self.PROPERTY_DOCUMENT_PHASE_OTP = SHOWSUITE.PROPERTY_DOCUMENT_PHASE_OTP;

        self.selection_settings_error = {};
        self.checkAll = false;

        self.propertySelectionPhaseIndicators = [
            {id: self.PROPERTY_DOCUMENT_PHASE_EOI, name: 'EOI'},
            {id: self.PROPERTY_DOCUMENT_PHASE_BOOKING, name: 'BOOKING'},
            {id: self.PROPERTY_DOCUMENT_PHASE_OTP, name: 'OTP'}
        ];

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.language = self.$localStorage['language'];
        self.localizeParam = {
            name:''
        };

        self.selection_obj = [];
        self.parent_selections = [];
        self.expiry_date_picker = null;

        self.selection_view = true;
        self.stack_view = false;
        
        self.selected_units_view = false;
        self.selected_units_list = [];

        self.selected_units_count = 0;
        self.selected_units_display = 0;
        self.temp_units_arr = [];
        self.selected_units_arr = [];
        self.units_arr_clone = [];

        self.availableUnits = [];
        self.floor_types = {};
        self.floor_plan_types = [];

        self.select_status = [];
        self.search_types = [];
        self.search_categories = [];
        self.search_price_types = [];
        self.search_floorPlan = [];
        self.selectedAgency = [];
        self.filtered_units = [];

        self.sortColumn = 'block_no';
        self.reverseSort = false;

        self.unit_status = 0;

        self.offset = 0;
        self.limit = 10;

        self.current = 1;
        self.jump_to_page = 1;

        self.pageChanged = function(newPage) {

            self.loadUnits(newPage);
        };

        self.setPageOptions();

        self.unitStatuses = [];
        self.unitStatusesFilter = [];
        self.edited_fields= [];
        self.editableStatus = [
            self.UNIT_STATUS_DRAFT,
            self.UNIT_STATUS_LISTED,
            self.UNIT_STATUS_SOLD,
            self.UNIT_STATUS_SPECIAL_RESERVED
        ];

        self.OPTIONS_MAP=[
            {"id": "2", "value":  "Category"},
            {"id": "3", "value":  "Type"},
            {"id": "4", "value":  "Name"},
            {"id": "5", "value": "Price"},
            {"id": "6", "value": "Status"},
            {"id": "7", "value": "Commission/Incentives"},
        ];

        self.PRICE_MAP=[
            {"id": "1", "value":  "Fixed Price"},
            {"id": "2", "value":  "Increase By Percentage"},
            {"id": "3", "value":  "Decrease By Percentage"},
            {"id": "4", "value":  "Increase By Price"},
            {"id": "5", "value": "Decrease By Price"},
        ];

        self.types = self.SSConfigService.serverConfig.unit_types;
        self.categories = self.SSConfigService.serverConfig.unit_categories;
        self.price_types = self.SSConfigService.serverConfig.unit_price_types;

        let url = 'properties/' + self.data.property_id + '/floorplans';

        // let params = {
        //     'include_assets': 1
        // };

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.floorPlans = response.data.floorplans;

            jQuery.each(self.floorPlans, function (i, status) {
                self.search_floorPlan.push({id: status.name, title: status.name});
            });

        });

        jQuery.each(self.SSConfigService.serverConfig.unit_statuses, function (i, status) {
            if (self.editableStatus.indexOf(status.id) != -1) {
                self.unitStatuses.push(status);
                self.select_status.push({id:status.name, title:status.name});
            }
            self.unitStatusesFilter.push(status);
        });

        jQuery.each(self.types, function (i, status) {
            self.search_types.push({id:status.name, title:status.name});
        });

        jQuery.each(self.categories, function (i, status) {
            self.search_categories.push({id:status.name, title:status.name});
        });

        jQuery.each(self.price_types, function (i, status) {
            self.search_price_types.push({id:status.name, title:status.name});
        });


        self.modifyChanges = false;
        self.params = {
            property_id: self.data.property_id,
            status: self.unitStatuses[0]
        };

        self.param = {
            property_id: self.data.property_id
        };

        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };

        self.setSelectionPriceTypeValues();
        self.setSelectionTypeValues();
        self.setSelectionGroupValues();
        self.prepareSelectionSettings();
        self.getPropertySelections();

        // self.getUnitStacks();

        self.getPropertyDocuments();

        self.getUnits();

        // self.getFloorPlans();
        // watch for check all checkbox
        // self.$scope.$watch(function () {
        //     return self.checkboxes.checked;
        // }, function (value) {


        //     jQuery.each(self.units, function (i, item) {
        //         // if (self.isUnitEditable(item)) {
        //         self.checkboxes.items[item.id] = value;
        //         // }
        //     });
        // });
    }

    initLocaleString(){
        const self = this;
        self.localeStrings = [];
        if(self.selections) {
            self.selections.forEach(function (val) {
                self.localeStrings['selection.' + val.id + '.selection_text'] = self.toLocaleDictionary('selections', val.id, 'selection_text', val.selection_text);
                self.localeStrings['selection.' + val.id + '.category'] = self.toLocaleDictionary('selections', val.id, 'category', val.category);
            });
        }

    }

    toLocaleDictionary(table ,id, column_name, original_value){
        const self = this;

        if(!table || !id || !column_name)
            return original_value;

        if(self.$cookies.get('lang') == 'en')
            return original_value;

        if(self.language){
            let result = self.language.filter(function (row) {

                return table+'.'+id+'.'+column_name+'.'+self.$cookies.get('lang') == row.key;
            });
            if(result.length && result[0].value != '')
                return result[0].value;
            else
                return original_value;
        }
        else{
            return original_value;
        }
    }

    selectLanguageChanged(){
        const self = this;
        //Adding data to localizeParams
        self.localizeParam.name = self.getLocalizationValue('selections',self.update_selection_id,'name');
        self.localizeParam.selection_text = self.getLocalizationValue('selections',self.update_selection_id,'selection_text');
        self.localizeParam.category = self.getLocalizationValue('selections',self.update_selection_id,'category');
        // self.localizeParam.selection_choices = self.getLocalizationValue('selections',self.update_selection_id,'selection_choices');
        self.localizeParam.default_choice = self.getLocalizationValue('selections',self.update_selection_id,'default_choice');
    }

    getLocalizationValue(table ,id, column_name){
        const self = this;
        if(!table || !id || !column_name)
            return;
        if(self.language){
            let result = self.language.filter(function (row) {

                return table+'.'+id+'.'+column_name+'.'+self.selectedLanguage == row.key;
            });
            if(result.length)
                return result[0].value;
            else
                return '';
        }
    }

    createLocalizationKey(table ,id, column_name){
        const self = this;
        if(!table || !id || !column_name)
            return;
        return table+'.'+id+'.'+column_name+'.'+self.selectedLanguage;
    }

    convertLocalizationParams(){
        const self = this;
        let params = {};
        params[self.createLocalizationKey('selections',self.update_selection_id,'name')] = self.localizeParam.name;
        params[self.createLocalizationKey('selections',self.update_selection_id,'selection_text')] = self.localizeParam.selection_text;
        params[self.createLocalizationKey('selections',self.update_selection_id,'category')] = self.localizeParam.category;
        // params[self.createLocalizationKey('selections',self.update_selection_id,'selection_choices')] = self.localizeParam.selection_choices;
        params[self.createLocalizationKey('selections',self.update_selection_id,'default_choice')] = self.localizeParam.default_choice;
        return params;
    }

    saveLanguageParam(){
        const self = this;

        if(!self.selectedLanguage){
            self.selectedLanguageError = 'Select Language to save';
            return;
        }

        let params = self.convertLocalizationParams();

        let url = 'language';

        loading(true);
        self.SSHttpService.postAPIRequest(url,params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'All data is saved successfully.');
            self.updateLocalLanguage();
        });
    }

    updateLocalLanguage(){
        const self = this;
        let url = 'language';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.$localStorage['language'] = response.data.language;
            self.language = self.$localStorage['language'];
            self.$cookies.put('language-md5', response.data.md5);
            self.initLocaleString();
        });
    }

    getUnits() {
        const self = this;

        if (!self.property.id)
            return;

        self.stacks = [];
        self.units = [];
        self.units_master = [];
        self.edited_units = [];
        self.firstWatch = null;

        let url = 'sec/developer/properties/' + self.property.id + '/units';
        let params = {
            offset: 0,
            limit: 1500 // Consider max value
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.UNITS_POPULATED = true;
            self.stacks = response.data.stacks;
            let units = angular.copy(response.data.property_units);
            units = self.SSUtilService.getSortedUnits(units, false, 'named_id');
            self.units = angular.copy(units);

            jQuery.each(self.units, function (i, unit) {
                self.formatUnitData(unit);
            });

            self.unitsBackup = self.units;

            self.count = self.unitsBackup.length;

            jQuery.each(self.units, function (i, item) {
                self.$scope.$watchCollection(function () {
                    return self.units[i];
                }, function (newValue, oldValue) {

                    if ( self.firstWatch=="20" ) {
                        self.edited_units.push(newValue.id);
                    }
                });
            });

            self.units_master = angular.copy(self.units);
            self.units_master_converted = angular.copy(self.units);

            self.loadUnits(undefined, self.units_master);
        });
    }

    // CLIENT SIDE PAGINATION
    loadUnits(page, units){
        const self = this;

        // if(self.unit_status && !filtered){
        //     self.filterUnitsByStatus(self.unit_status);
        // }

        if(page) {
            self.offset = (page * self.limit) - self.limit;
            self.current = page;
            self.jump_to_page = page;
        }

        if(!units){
            if (self.filtered_units && self.filtered_units.length > 0) {
                units = angular.copy(self.filtered_units);
            } else {
                units = self.unitsBackup;
            }
        }

        self.units_master = units.slice(self.offset, self.limit + self.offset);
        self.count = units.length;

        // SET 'CURRENT SELECTED UNITS' COUNT
        if(parseInt(self.limit) < parseInt(self.units_master.length)){
            self.selected_units_display = self.limit;
        }
        else{
            self.selected_units_display = self.units_master.length;
        }

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        let total_pages = Math.ceil(self.count / self.limit);
        self.setTotalPagesOptions(total_pages);
    }

    getProperty() {
        const self = this;

        if (!self.data.property_id)
            return;

        self.property = null;

        let url = 'sec/developer/properties/' + self.data.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.property = response.data.property;
            self.getPropertySelections();
        });
    }

    getPropertySelections() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/selections';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.selections = _.sortBy(response.data.selections, 'order');
            self.initLocaleString();

            if (self.selections) {

                for (var index = 0; index < self.selections.length; index++) {
                        self.parent_selections.push({
                            'id': self.selections[index].id,
                            'name': self.selections[index].selection_text
                        });
                }
                self.$timeout(function () {
                    $("select.eoi-select#parent_selection_select").niceSelect('update');
                    $("select.eoi-select#phase_ind_selection_select").niceSelect('update');
                });
            }
        });
    }

    setSelectionPriceTypeValues() {
        const self = this;

        self.selection_price_types = [
            {
                'id': 0,
                'name': 'SELECTION WITHOUT PRICE'
            },
            {
                'id': 1,
                'name': 'SELECTION WITH PRICE'
            }
        ];

        self.$timeout(function () {
            $("select.eoi-select#selection_select_price").niceSelect('update');
        });
    }

    setSelectionTypeValues() {
        const self = this;

        self.selection_types = [
            // {
            //     'id': self.QUESTION_TYPE_YES_NO,
            //     'name': 'YES/NO'
            // },
            // {
            //     'id': self.QUESTION_TYPE_YES_NO_NA,
            //     'name': 'Yes/No/NA'
            // },
            // {
            //     'id': self.QUESTION_TYPE_TEXT,
            //     'name': 'TEXT'
            // },
            // {
            //     'id': self.QUESTION_TYPE_NUMBER,
            //     'name': 'NUMBER'
            // },
            {
                'id': self.QUESTION_TYPE_SELECT,
                'name': 'SELECT'
            },
            {
                'id': self.QUESTION_TYPE_CHECKBOX,
                'name': 'CHECKBOX'
            },
            {
                'id': self.QUESTION_TYPE_RADIO,
                'name': 'RADIO'
            }
        ];

        self.selection_types_edit = [
            // {
            //     'id': self.QUESTION_TYPE_YES_NO,
            //     'name': 'YES/NO'
            // },
            // {
            //     'id': self.QUESTION_TYPE_YES_NO_NA,
            //     'name': 'Yes/No/NA'
            // },
            // {
            //     'id': self.QUESTION_TYPE_TEXT,
            //     'name': 'TEXT'
            // },
            // {
            //     'id': self.QUESTION_TYPE_NUMBER,
            //     'name': 'NUMBER'
            // },
            {
                'id': self.QUESTION_TYPE_SELECT,
                'name': 'SELECT'
            },
            {
                'id': self.QUESTION_TYPE_CHECKBOX,
                'name': 'CHECKBOX'
            },
            {
                'id': self.QUESTION_TYPE_RADIO,
                'name': 'RADIO'
            }
        ];

        self.$timeout(function () {
            $("select.eoi-select#selection_select").niceSelect('update');
        });
    }

    setSelectionTypeValuesAll() {
        const self = this;

        self.selection_types_edit = [
            // {
            //     'id': self.QUESTION_TYPE_YES_NO,
            //     'name': 'YES/NO'
            // },
            // {
            //     'id': self.QUESTION_TYPE_YES_NO_NA,
            //     'name': 'Yes/No/NA'
            // },
            // {
            //     'id': self.QUESTION_TYPE_TEXT,
            //     'name': 'TEXT'
            // },
            // {
            //     'id': self.QUESTION_TYPE_NUMBER,
            //     'name': 'NUMBER'
            // },
            {
                'id': self.QUESTION_TYPE_SELECT,
                'name': 'SELECT'
            },
            {
                'id': self.QUESTION_TYPE_CHECKBOX,
                'name': 'CHECKBOX'
            },
            {
                'id': self.QUESTION_TYPE_RADIO,
                'name': 'RADIO'
            }
        ];

        self.$timeout(function () {
            $("select.eoi-select#selection_select").niceSelect('update');
        });
    }

    setSelectionTypeValuesOnlyCheckboxAndRadio() {
        const self = this;

        self.selection_types_edit = [
            // {
            //     'id': self.QUESTION_TYPE_YES_NO,
            //     'name': 'YES/NO'
            // },
            // {
            //     'id': self.QUESTION_TYPE_YES_NO_NA,
            //     'name': 'Yes/No/NA'
            // },
            // {
            //     'id': self.QUESTION_TYPE_TEXT,
            //     'name': 'TEXT'
            // },
            // {
            //     'id': self.QUESTION_TYPE_NUMBER,
            //     'name': 'NUMBER'
            // },
            // {
            //     'id': self.QUESTION_TYPE_SELECT,
            //     'name': 'SELECT'
            // },
            {
                'id': self.QUESTION_TYPE_CHECKBOX,
                'name': 'CHECKBOX'
            },
            {
                'id': self.QUESTION_TYPE_RADIO,
                'name': 'RADIO'
            }
        ];

        self.$timeout(function () {
            $("select.eoi-select#selection_select").niceSelect('update');
        });
    }

    setSelectionGroupValues() {
        const self = this;

        self.selection_groups = [
            {
                'id': self.QUESTION_GROUP_INDIVIDUAL,
                'name': 'Individual'
            },
            {
                'id': self.QUESTION_GROUP_COMPANY,
                'name': 'Company'
            }
        ];

        self.$timeout(function () {
            $("select.eoi-select#group_select").niceSelect('update');
        });
    }

    renderHtml(content) {
        const self = this;

        // WEB-3597 — allow-list sanitise rich text before trusting it for ng-bind-html.
        return self.sce.trustAsHtml(window.ssSanitizeHtml(content));
    }

    showChoices() {
        const self = this;

        let flag = false;

        if (self.selection_type == self.QUESTION_TYPE_SELECT || self.selection_type == self.QUESTION_TYPE_CHECKBOX
            || self.selection_type == self.QUESTION_TYPE_RADIO) {
            flag = true;
        }

        return flag;
    }

    getSelectionTypeName(type_id) {
        const self = this;

        let type_name = '';

        try {
            type_name = self.selection_types.find(x => x.id == type_id).name;
        } catch (ex) {
            console.log(ex);
        }

        return type_name;
    }

    onDeleteSelection(selection_id) {
        const self = this;

        self.hideModals();
        self.showDeleteModal = true;
        self.delete_selection_id = selection_id;
        $('#deleteSelectionModal').modal('show');
    }

    deleteSelection() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            let url = 'sec/developer/properties/' + self.property_id + '/selections/' + self.delete_selection_id + '/delete';
            self.hideModals();

            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.warning('Warning!', 'This selection can not be deleted.');
                    return;
                }
                self.SSAlertService.success('Success!', 'Selection deleted successfully');

                self.selections = $.grep(self.selections, function (e) {
                    return e.id != self.delete_selection_id;
                });

                self.selections = _.sortBy(self.selections, 'order');
                self.initLocaleString();

                self.parent_selections = [];
                for (var index = 0; index < self.selections.length; index++) {
                    if (!self.selections[index].parent_selection_id) {
                        self.parent_selections.push({
                            'id': self.selections[index].id,
                            'name': self.selections[index].selection_text
                        });
                    }
                }
                self.updateParentSelectionSelect();

            });
        });
    }

    initEditorData() {
        const self = this;

        let editorData = self.selection_text;
        $('div#froala-editor').html(editorData);

        $('div#froala-editor').froalaEditor('destroy');

        var buttons = [
            'bold', 'italic', 'underline', 'strikeThrough',
            '|', 'subscript', 'superscript',
            '|', 'paragraphFormat', 'paragraphStyle', 'inlineStyle', 'align',
            '|', 'formatOL', 'formatUL', 'outdent', 'indent', 'selectAll',
            '-', 'insertHR', 'clearFormatting',
            '|', 'html',
            '|', 'undo', 'redo',
        ];

        // Init Froala Editor
        let froalaEditor = $('div#froala-editor').froalaEditor({
            key: 'HH3E1A4A4wB1B1E1D2E1E4I3B2A9A5jdpvmhitjzF4bmn==',
            toolbarInline: true,
            placeholderText: '',
            charCounterCount: false,
            height: 200,

            toolbarButtons: buttons,
            toolbarButtonsMD: buttons,
            toolbarButtonsSM: buttons,
            toolbarButtonsXS: buttons,

            htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
            htmlRemoveTags: []
        });

        $('.fr-toolbar').css('z-index', '10001');
        $('.fr-tooltip').css('z-index', '10001');
    }

    onUpdateSelection(selection_id) {
        const self = this;

        self.selectedLanguage = '';

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            self.hideModals();
            self.selection_documents = {};
            self.showSelectionModal = true;
            self.update_selection_id = selection_id;

            self.resetErrors();
            self.add_selection = false;
            self.update_selection = true;
            self.selection_view = true;
            self.stack_view = false;
            self.selected_units_view = false;

            let selection_obj = self.selections.find(x => x.id == selection_id);
            self.edit_selection = selection_obj;
            self.initializeFields(selection_obj);

            $('#addEditSelectionModal').modal('show');
            self.update_is_with_price();
            // self.initEditorData();

            self.$timeout(function () {
                $("select.eoi-select[id^=document_type]").niceSelect('update');
            });
        });

    }

    updateSelection() {
        const self = this;

        self.resetErrors();

        let url = 'sec/developer/properties/' + self.property_id + '/selections/' + self.update_selection_id;
        // self.selection_text = $('div#froala-editor').froalaEditor('html.get');
        let choices = '';
        if (self.selection_choices) {
            choices = JSON.stringify(self.selection_choices);
        }

        let params = {
            parent_selection_id: self.parent_selection_id,
            parent_selection_answer: self.parent_selection_answer,
            selection_text: self.selection_text,
            type: self.selection_type,
            // group: self.selection_group,
            choices: choices,
            order: self.selection_order,
            is_active: self.is_active ? 1 : 0,
            is_required: self.is_required ? 1 : 0,
            units: self.prepareUpdateSelectionUnits(),
            documents: '',
            name: self.name,
            category: self.category,
            selection_class: self.selection_class,
            characteristic: self.characteristic,
            file_uri: self.file_uri,
            is_with_price: self.is_with_price,
            phase_ind: self.phase_ind
        };
        
        if (!self.isValidInput()) {
            return;
        }

        if (Object.keys(self.selection_documents).length) {
            let document_objects_arr = [];

            $.each(self.selection_documents, function(name, document_object) {
                if(document_object.id){
                    document_objects_arr.push([name, document_object.id]);
                }
            });

            params.documents = JSON.stringify(document_objects_arr);
        }

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Selection updated successfully');

            // self.edit_selection = angular.copy(response.data.selections[0]);
            self.selections = self.selections.map(x => response.data.selections.find(o => o.id === x.id) || x);

            self.selections = _.sortBy(self.selections, 'order');
            self.initLocaleString();

            self.parent_selections = [];
            for (var index = 0; index < self.selections.length; index++) {
                if (!self.selections[index].parent_selection_id) {
                    self.parent_selections.push({
                        'id': self.selections[index].id,
                        'name': self.selections[index].selection_text
                    });
                }
            }
            self.updateParentSelectionSelect();
        });
    }

    viewSelectedUnits(units){
        const self = this;

        if(!units){
            return;
        }

        self.selected_units_list = [];

        $.each(units, function(index, unit_id) {
            let unit = self.unitsBackup.find(x => x.id == unit_id);

            if (unit) {
                self.selected_units_list.push(unit);
            }
            // if(typeof obj == "number"){
            //     let unit = self.availableUnits.find(x => x.unit_id == obj);
            //     if(unit){
            //         self.selected_units_list.push(unit);
            //     }
            // }
            // else{
            //     self.selected_units_list.push(obj);
            // }
        });
        
        self.selection_view = false;
        self.stack_view = false;
        self.selected_units_view = true;
    }

    cancelSelectedUnitsView(){
        const self = this;

        self.selection_view = true;
        self.stack_view = false;
        self.selected_units_view = false;
    }

    addSelection() {
        const self = this;

        self.selectedLanguage = '';

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self.hideModals();
            self.showSelectionModal = true;
            self.resetErrors();
            self.resetFields();

            self.update_selection = false;
            self.add_selection = true;
            self.selection_view = true;
            self.stack_view = false;
            self.selected_units_view = false;

            $('#addEditSelectionModal').modal('show');
            self.clearSelectionFields();
            self.document_objects = [];
            self.edit_selection = {};
        });
    }

    clearSelectionFields() {
        const self = this;

        self.is_with_price = null;
        self.selection_text = null;
        self.selection_type = null;
        self.parent_selection_id = null;
        self.selection_group = null;
        self.selection_choices = [];
        self.default_choice = null;
        self.name = null;
        self.category = null;
        self.selection_class = null;
        self.characteristic = null;
        self.file_uri = null;

        self.selection_order = null;
        self.is_active = null;
        self.is_required = null;
        self.phase_ind = null;

        self.parent_selection_answer = null;
        self.$timeout(function () {
            $("select.eoi-select#parent_selection_select").niceSelect('update');
            $("select.eoi-select#phase_ind_selection_select").niceSelect('update');
        });
        
        self.$timeout(function () {
            $("select.eoi-select#group_select").niceSelect('update');
        });

        self.document_objects = [];
        self.$timeout(function () {
            $("select.eoi-select[id^=document_type]").niceSelect('update');
        });
    }

    saveSelection() {
        const self = this;

        self.resetErrors();

        let url = 'sec/developer/properties/' + self.property_id + '/selections';
        // self.selection_text = $('div#froala-editor').froalaEditor('html.get');

        let choices = '';
        if (self.selection_choices) {
            choices = JSON.stringify(self.selection_choices);
        }

        let params = {
            parent_selection_id: self.parent_selection_id,
            parent_selection_answer: self.parent_selection_answer,
            selection_text: self.selection_text,
            type: self.selection_type,
            // group: self.selection_group,
            choices: choices,
            order: self.selection_order,
            is_active: self.is_active ? 1 : 0,
            is_required: self.is_required ? 1 : 0,
            units: self.prepareUpdateSelectionUnits(),
            documents: '',
            name: self.name,
            category: self.category,
            selection_class: self.selection_class,
            characteristic: self.characteristic,
            file_uri: self.file_uri,
            is_with_price: self.is_with_price,
            phase_ind: self.phase_ind
        };

        if (!self.isValidInput()) {
            return;
        }

        // if (self.selected_units_arr.length > 0) {
        //     params.units = self.selected_units_arr.map(e => e.unit_id).join(",");
        // } else{
        //     params.units = '';
        // }

        if (self.document_objects && self.document_objects.length > 0) {
            let document_objects_arr = [];

            $.each(self.document_objects, function(index, document_object) {
                document_objects_arr.push([document_object.name, document_object.document_type]);
            });

            params.documents = JSON.stringify(document_objects_arr);
        }

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Selection added successfully.');
            self.selections.push(response.data.selections[0]);

            self.update_selection_id = response.data.selections[0].id;
            if (self.is_upload) {
                self.uploadSelectionPDFSelection(self.updateSelectionAfterPDFUpload);
            }

            self.selections = _.sortBy(self.selections, 'order');
            self.initLocaleString();

            self.parent_selections = [];
            for (var index = 0; index < self.selections.length; index++) {
                if (!self.selections[index].parent_selection_id) {
                    self.parent_selections.push({
                        'id': self.selections[index].id,
                        'name': self.selections[index].selection_text
                    });
                }
            }
            self.updateParentSelectionSelect();
        });
    }

    updateSelectionAfterPDFUpload(self) {
        let url = 'sec/developer/properties/' + self.property_id + '/selections/' + self.update_selection_id;
        // self.selection_text = $('div#froala-editor').froalaEditor('html.get');
        let choices = '';
        if (self.selection_choices) {
            choices = JSON.stringify(self.selection_choices);
        }

        let params = {
            parent_selection_id: self.parent_selection_id,
            parent_selection_answer: self.parent_selection_answer,
            selection_text: self.selection_text,
            type: self.selection_type,
            // group: self.selection_group,
            choices: choices,
            order: self.selection_order,
            is_active: self.is_active ? 1 : 0,
            is_required: self.is_required ? 1 : 0,
            units: '',
            documents: '',
            name: self.name,
            category: self.category,
            selection_class: self.selection_class,
            characteristic: self.characteristic,
            file_uri: self.file_uri,
            is_with_price: self.is_with_price,
            phase_ind: self.phase_ind
        };

        if (self.selected_units_arr.length > 0) {
            params.units = self.selected_units_arr.map(e => e.unit_id).join(",");
        } else{
            params.units = '';
        }

        if (self.document_objects && self.document_objects.length > 0) {
            let document_objects_arr = [];

            $.each(self.document_objects, function(index, document_object) {
                document_objects_arr.push([document_object.name, document_object.document_type]);
            });

            params.documents = JSON.stringify(document_objects_arr);
        }

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
        });
    }

    isValidInput() {
        const self = this;

        let isValid = true;

        if (!self.is_with_price && self.is_with_price != 0) {
            self.error_is_with_price = 'The selection text field is required.';
            isValid = false;
        }

        if (!self.selection_text) {
            self.error_selection_text = 'The selection text field is required.';
            isValid = false;
        }
        if (!self.selection_type) {
            self.error_selection_type = 'The selection type field is required.';
            isValid = false;
        }

        if (!self.name) {
            self.error_name = 'The selection name field is required.';
            isValid = false;
        }

        if (self.category && self.category.length > 255) {
            self.error_category = 'Selection Category character limit exceeds 255. Please limit it below 255 characters.';
            isValid = false;
        }

        if (self.selection_choices && self.selection_choices.length > 0) {
            $.each(self.selection_choices, function(index, choice) {
                choice.error_name = '';
                choice.error_price = '';
                if (!choice.name) {
                    choice.error_name = 'The choice is required.';
                    isValid = false;
                }

                if ((!choice.price && choice.price != 0) && self.is_with_price) {
                    choice.error_price = 'The price is required.';
                    isValid = false;
                }
            });

            if (self.selection_type && self.selection_type == self.QUESTION_TYPE_RADIO) {
                let default_choices = self.selection_choices.filter(x => x.is_default == true);

                if (default_choices.length > 1) {
                    self.error_selection_choices = 'Plase select only one default choice.';
                    isValid = false;
                }
            }
        } else {
            isValid = false;
            self.error_selection_choices = 'Please enter at least one choice.';
        } 

        $.each(self.document_objects, function(index, document_object) {
            if (!document_object.document_type) {
                document_object.error_document_type = 'The document type is required.';
                isValid = false;
            }
        });

        return isValid;
    }

    addSelectionObject() {
        const self = this;

        let new_document_object = {
            'name': '',
            'document_type': 0
        };

        self.document_objects.push(new_document_object);
        self.$timeout(function () {
            $("select.eoi-select[id^=document_type]").niceSelect('update');
        });
    }

    initializeFields(selection) {
        const self = this;

        // initialize selected units
        self.checkboxes = {items: {}};
        $.each(selection.units, function(index, unit_id){
            self.checkboxes.items[unit_id] = true;
        });
        self.is_with_price = selection.is_with_price;
        self.selection_text = selection.selection_text;
        self.selection_type = selection.type;
        self.parent_selection_id = selection.parent_selection_id;
        self.selection_group = selection.group;
        if (selection.choices) {
            self.selection_choices = selection.choices;
        } else {
            self.selection_choices = [];
        }

        self.name = selection.name;
        self.category = selection.category;
        self.selection_class = selection.selection_class;
        self.characteristic = selection.characteristic;
        self.file_uri = selection.file_uri;
        self.phase_ind = selection.phase_ind;

        self.selection_order = selection.order;
        self.is_active = selection.is_active ? true : false;
        self.is_required = selection.is_required ? true : false;

        self.$timeout(function () {
            $("select.eoi-select#selection_select").niceSelect('update');
            $("select.eoi-select#selection_select_price").niceSelect('update');
            $("select.eoi-select#parent_selection_select").niceSelect('update');
            $("select.eoi-select#phase_ind_selection_select").niceSelect('update');
        });

        if (selection.parent_selection_id) {
            self.parent_selection_answer = selection.parent_selection_answer;
        }
        if (selection.group) {
            self.$timeout(function () {
                $("select.eoi-select#group_select").niceSelect('update');
            });
        }

        // self.document_objects = [];
        // if (selection.documents && selection.documents.length > 0) {
        //     $.each(selection.documents, function(index, document) {
        //         self.document_objects.push({name: document[0], document_type: document[1]});
        //     });
        //     self.$timeout(function () {
        //         $("select.eoi-select[id^=document_type]").niceSelect('update');
        //     });
        // }

        self.selection_documents = {};
        if (selection.documents && selection.documents.length > 0) {
            $.each(selection.documents, function(index, document) {
                let choiceName = document[0] ? document[0] : '__BLANK__';
                if (!(self.selection_choices.find(x => x.name === choiceName))) { // The blank choice handling
                    self.selection_choices.push({name: choiceName, price: 0});
                }
                self.selection_documents[choiceName] = {id: document[1]};
            });
            self.$timeout(function () {
                $("select.eoi-select[id^=document_type]").niceSelect('update');
            });
        }

    }

    removeSelectionObject(document_object) {
        const self = this;

        self.document_objects = $.grep(self.document_objects, function (e) {
            return e.$$hashKey != document_object.$$hashKey;
        });
    }

    updateParentSelectionSelect() {
        const self = this;

        self.$timeout(function () {
            $("select.eoi-select#parent_selection_select").niceSelect('update');
        });
    }

    resetErrors() {
        const self = this;

        self.error_selection_text = null;
        self.error_selection_type = null;
        self.error_document_type = null;
        self.error_default_choice = null;
        self.error_category = null;
        self.error_selection_choices = null;
        self.error_is_with_price = null;

        $.each(self.document_objects, function(index, document_object) {
            document_object.error_name = null;
            document_object.error_document_type = null;
        });
    }

    resetFields() {
        const self = this;

        self.update_selection = false;
        self.add_selection = false;

        self.parent_selection_id = null;
        self.parent_selection_answer = null;
        self.selection_text = null;
        self.selection_type = null;
        self.selection_group = null;
        self.selection_choices = [];
        self.selection_order = null;
        self.phase_ind = null;

        self.$timeout(function () {
            $("select.eoi-select#selection_select").niceSelect('update');
            $("select.eoi-select#selection_select_price").niceSelect('update');
        });

        self.$timeout(function () {
            $("select.eoi-select#parent_selection_select").niceSelect('update');
            $("select.eoi-select#phase_ind_selection_select").niceSelect('update');
        });

        self.$timeout(function () {
            $("select.eoi-select#group_select").niceSelect('update');
        });
    }

    hideModals() {
        const self = this;

        self.showSelectiontModal = false;
        self.showDeleteModal = false;

        if ($('#addEditSelectionModal').is(':visible')) $('#addEditSelectionModal').modal('hide');
        if ($('#deleteSelectionModal').is(':visible')) $('#deleteSelectionModal').modal('hide');
    }

    getUnitStacks() {
        const self = this;

        self.units = null;

        let url = 'properties/' + self.property_id + '/stacks';
        let params = {

            'return_property': true,
            'property_columns': 'id,named_id,name,type,product_type,status,location,country,region',
            'return_stack': true,
            'stack_columns': 'id,named_id,name',
            'include_units': true,
            'unit_columns': 'id,named_id,floor_no,floor_order,unit_no,unit_order,house_no,category,type,name,baths,status,price,start_price,end_price,size_ft2,psf'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.stacks = response.data.property_stacks;
            self.processServerData();
            self.getPropertyUnitTypes();

        });
    }

    processServerData() {
        const self = this;

        jQuery.each(self.stacks, function (i, stack) {
            stack.floorsData = self.SSUtilService.getFloorWiseUnits(stack.units);
            stack.availableUnits = self.filterAvailableUnits(stack.units);
        });

        // Select first stack by default
        self.selectedStackId = (self.selectedStackId) ? self.selectedStackId : self.stacks[0].id;
    }

    filterViewStack(className) {
        var buttons = $("div.scroll").find("button");

        //Make all visible
        var invisible_buttons = $("div.scroll").find("button.greyout");
        jQuery.each(invisible_buttons, function (i, button) {
            $(button).removeClass("greyout");
        });

        //Make all invisible other than className
        if (className) {
            jQuery.each(buttons, function (i, button) {
                if (!$(button).hasClass(className)) {
                    $(button).addClass("greyout");
                }
            });
        }
    }

    initSelectizejs() {
        const self = this;

        //Reset selectize
        self.category_type = [];
        self.floor_plan_type = [];

        $('#selectize_category').selectize({
            delimiter: ',',
            persist: false,
            create: function (input) {
                return {
                    value: input,
                    text: input
                }
            }
        });

        $('#selectize_floor_plan').selectize({
            delimiter: ',',
            persist: false,
            create: function (input) {
                return {
                    value: input,
                    text: input
                }
            }
        });

        self.$timeout(function () {
            $("#selectize_category")[0].selectize.clear();
            $("#selectize_floor_plan")[0].selectize.clear();
        });        
    }

    filterFloorPlan() {
        const self = this;

        let unit_types = self.floor_plan_type;

        if (unit_types.length > 0) {

            // Make all invisible
            var buttons = $("div.scroll").find("button");
            $(buttons).addClass("greyout");

            // Now make all visible for selected floor plan type
            for (var index = 0; index < unit_types.length; index++) {
                let type = self.floor_types[unit_types[index]];
                for (var j = 0; j < type.floor_units.length; j++) {
                    let unit = type.floor_units[j];
                    // Get unit button
                    let button = $('#' + unit.named_id)
                    if ($(button).hasClass("greyout")) {
                        $(button).removeClass("greyout");
                    }
                }
            }
        } else {
            
        }
    }

    getPropertyUnitTypes() {
        const self = this;

        self.propertyUnitCategories = [];

        jQuery.each(self.stacks, function (i, stack) {
            jQuery.each(stack.units, function (j, unit) {
                let category = null;
                if (unit.category in self.UNIT_CATEGORIES_MAP) {
                    category = self.UNIT_CATEGORIES_MAP[unit.category];
                } else {
                    category = self.UNIT_CATEGORIES_MAP[0];
                }

                if (self.propertyUnitCategories.indexOf(category) == -1) {
                    self.propertyUnitCategories.push(category);
                }

                // Process floor plan data
                let floor_category = unit.floor_plan;

                if (self.floor_types.hasOwnProperty(floor_category)) {

                    self.floor_types[floor_category]["floor_units"].push(unit);

                } else {

                    self.floor_types[floor_category] = {};
                    self.floor_types[floor_category]["name"] = floor_category;
                    self.floor_types[floor_category]["floor_units"] = []
                    self.floor_types[floor_category]["floor_units"].push(unit);

                    self.floor_plan_types.push({'id': unit.floor_plan, 'name': unit.floor_plan});
                }
            });
        });
    }

    getUnitCellClass(unit) {
        const self = this;

        let cls = '';

        if (!unit.category) {
            cls = 'empty';
        } else if (unit.status == self.UNIT_STATUS_LISTED) {
            if (unit.category in self.UNIT_CATEGORIES_MAP) {
                cls = self.UNIT_CATEGORIES_MAP[unit.category].className;
            } else {
                cls = self.UNIT_CATEGORIES_MAP[0].className;
            }
        } else if (unit.status == self.UNIT_STATUS_SOLD) {
            cls = 'sold';
        } else if (unit.status == self.UNIT_STATUS_DRAFT) {
            cls = 'draft';
            //cls = self.UNIT_CATEGORIES_MAP[3].className;
        } else {
            cls = 'reserved';
        }

        return cls;
    }

    filterAvailableUnits(units) {
        const self = this;

        // Add units of 'Sold Status' to avoid unit selection issue on stack view
        let statuses = [self.UNIT_STATUS_LISTED, self.UNIT_STATUS_RESERVED, self.UNIT_STATUS_DRAFT, self.UNIT_STATUS_SOLD, self.UNIT_STATUS_BOOKED, self.UNIT_STATUS_SPECIAL_RESERVED];
        let filtered = [];

        _.each(units, function (unit) {
            if (statuses.indexOf(unit.status) !== -1) {
                unit["unit_num"] = self.getUnitNumber(unit);
                let stack = self.stacks.find(x => x.id == unit.stack_id);
                if(stack){
                    unit["block_no"] = stack.name;
                }
                filtered.push(unit);
                self.availableUnits.push({'unit_id': unit.id, 'unit_num': unit.unit_num, 'unit': unit});
            }
        });

        if (self.sortBy) {
            filtered = _.sortBy(filtered, function (item) {
                return item[self.sortBy];
            })
        }

        return filtered;
    }

    getUnitNumber(unit) {
        const self = this;

        if (unit.length < 1) {
            return '-';
        }
        return self.SSUtilService.getFullUnitNumber1(unit, true);
    }

    onSelectUnits(selection = null) {
        const self = this;

        self.units_arr_clone = [];

        // Initialize 'selectize' for floor plan filters
        self.initSelectizejs();

        // Remove previous data and initialize again
        self.removeAllUnits();

        self.initSelectionUnits(selection);

        if (selection) {
            //angular.copy([source], [destination]);
            if (selection.units && selection.units.length) {
                try {
                    selection.units = _.uniq(selection.units, 'unit_id');
                } catch (ex) {
                    console.log(ex);
                }
                self.temp_units_arr = angular.copy(selection.units);
            }
        }

        //Reset filter
        self.resetUnitSelector();

        self.loadUnits(undefined, self.unitsBackup);

        //Update checkbox
        self.updateUnitCheckboxes();

        self.selection_view = false;
        self.$timeout(function () {
            $('#addEditSelectionModal').find('.modal-dialog').css('max-width', '1300px');
        });
        self.stack_view = true;
    }

    initSelectionUnits(selection) {
        const self = this;

        self.selected_units_count = 0;
        self.selected_units_arr = [];

        if (!selection) {
            self.removeAllUnits();
            return;
        }

        // Remove 'disabled' prop in order to remove/apply selection
        $('.stack-view').css("opacity", "");
        $('.stack-view :button').prop('disabled', false);

        if (!selection.units || (selection.units && selection.units.length == 0)) {
            self.selectAll = true;
            $('.stack-view').css("opacity", "0.5");
            $('.stack-view :button').prop('disabled', true);
        } else if (selection.units) {

            self.selectAll = false;

            let units = selection.units;

            // Remove duplicates if any
            // It will throw error if already unique
            try {
                units = $.unique(units);
            } catch (ex) {
                console.log(ex);
            }

            try {
                for (var index = 0; index < units.length; index++) {
                    let unit_id = units[index];
                    let unitData = self.availableUnits.find(x => x.unit_id === unit_id);
                    if (unitData) {
                        let unit = unitData.unit;
                        unit["selected"] = true;
                        unit.clickedclass = true;
                        unit.selection = 'selected';
                        self.selected_units_arr.push(unitData);
                    }
                    self.selected_units_count += 1;
                }
            } catch (ex) {
                console.log(ex);
            }
        }
    }

    onProceedUnitSelection() {
        const self = this;

        self.select_units_error = "";

        var filteredUnits = Object.keys(self.checkboxes.items).reduce((p, c) => {    
          if (self.checkboxes.items[c]) p[c] = self.checkboxes.items[c];
          return p;
        }, {});

        self.temp_units_arr = Object.keys(filteredUnits);

        if (self.temp_units_arr.length == 0) {
            //Display Error message
            self.select_units_error = "Please select at least 1 unit to proceed."
            return;
        }

        self.edit_selection.units = angular.copy(self.temp_units_arr);

        // if (self.temp_units_arr.length) {

        //     try {
        //         self.temp_units_arr = _.uniq(self.temp_units_arr, 'unit_id');
        //     } catch (ex) {
        //         console.log(ex);
        //     }

        //     self.selected_units_arr = [];
        //     self.edit_selection.units = angular.copy(self.temp_units_arr);
        // } else if (self.selectAll) {
        //     //Do nothing
        //     self.edit_selection.units = [];
        // } else {
        //     //Display Error message
        //     self.select_units_error = "Please select at least 1 unit to proceed."
        //     return;
        // }

        self.stack_view = false;
        $('#addEditSelectionModal').find('.modal-dialog').css('max-width', '1300px');
        self.selection_view = true;
    }

    onCancelUnitSelection(selection = null) {
        const self = this;

        self.initSelectionUnits(selection);

        self.stack_view = false;
        $('#addEditSelectionModal').find('.modal-dialog').css('max-width', '1300px');
        self.selection_view = true;
    }

    toggleSelectAll() {
        const self = this;

        self.removeAllUnits();

        if (self.selected_units_count == 0) {
            if (self.selectAll) {
                $('.stack-view').css("opacity", "0.5");
                $('.stack-view :button').prop('disabled', true);
            } else {
                $('.stack-view').css("opacity", "");
                $('.stack-view :button').prop('disabled', false);
            }
        }
    }

    toggle_Unit_selection(unit) {
        const self = this;

        unit.clickedclass = unit.clickedclass ? false : true;
        if (unit.clickedclass) {
            unit.selection = 'selected';
            self.addUnit(unit);
        } else {
            unit.selection = 'unselected';
            self.removeUnit(unit);
        }
    }

    addUnit(unit) {
        const self = this;

        self.selected_units_count += 1;
        unit["selected"] = true;
        unit.clickedclass = true;
        unit.selection = 'selected';
        let unit_num = self.getUnitNumber(unit);

        self.temp_units_arr.push({'unit_id': unit.id, 'unit_num': unit_num, 'unit': unit});
    }

    removeUnit(unit) {
        const self = this;

        self.selected_units_count -= 1;
        if (unit.hasOwnProperty("selection")) {
            unit.selection = 'unselected';
            unit.clickedclass = false;
            unit["selected"] = false;
        }

        self.temp_units_arr = self.temp_units_arr.filter(x => x !== unit.id)
    }

    removeAllUnits() {
        const self = this;

        // Remove opacity and disabled property in order to remove units
        $('.stack-view').css("opacity", "");
        $('.stack-view :button').prop('disabled', false);

        for (var index = 0; index < self.temp_units_arr.length; index++) {
            if (self.temp_units_arr[index].hasOwnProperty('unit')) {
                let unit = self.temp_units_arr[index].unit;
                if (unit.hasOwnProperty("selection")) {
                    unit.selection = 'unselected';
                    unit.clickedclass = false;
                    unit["selected"] = false;
                }
            }
        }

        if (self.selectAll) {
            self.selectAll = true;
            $('.stack-view').css("opacity", "0.5");
            $('.stack-view :button').prop('disabled', true);
        } else if (!self.selectAll) {
            self.selectAll = false;
            $('.stack-view').css("opacity", "");
            $('.stack-view :button').prop('disabled', false);
        }

        self.temp_units_arr = [];
        self.selected_units_count = 0;
    }

    removeAarrayUnits(units) {
        const self = this;

        let temp_units_count = units.length;

        for (var index = 0; index < units.length; index++) {
            let unit = units[index].unit;
            if (unit.hasOwnProperty("selection")) {
                unit.selection = 'unselected';
                unit.clickedclass = false;
                unit["selected"] = false;
            }
        }

        self.selected_units_count -= temp_units_count;
    }

    clearUnitSelection(){
        const self = this;

        self.floor_plan_type = null;
        // Set first stack selected by default
        self.selectedStackId = self.stacks[0].id;

        $.each(self.stacks, function(index, stack){
            if(stack.units){
               $.each(stack.units, function(index, unit){
                    if(unit.clickedclass){
                        unit.clickedclass = false;
                    }
                    if(unit.selected){
                        unit["selected"] = false;
                    }
                    if(unit.selection == 'selected'){
                        unit.selection = 'unselected';
                    }
                }); 
            }
        });

        //Make all visible
        var buttons = $("div.scroll").find("button");
        $(buttons).removeClass("greyout");
    }
    //
    /**
     * Loads the property documents of kind "Selections Letter" into self.documents.
     *
     * @param {Function} [callback] Invoked once the documents have been loaded successfully.
     *                              Not invoked when the request fails, so callers can safely
     *                              treat it as a "documents are up to date" signal.
     * @returns {void}
     */
    getPropertyDocuments(callback) {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/documents';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.documents = response.data.property_documents.filter(x => x.document_kind === self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER);

            self.documents = _.sortBy(self.documents, 'order');
            self.$timeout(function () {
                $("select.eoi-select[id^=document_type]").niceSelect('update');
            });

            if (typeof callback === 'function') {
                callback();
            }
        });
    }

    /**
     * Tells whether the project already has at least one Selection Document
     * (property document of kind PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER).
     *
     * @returns {boolean} True when a selection document exists.
     * @remarks Relies on self.documents, which getPropertyDocuments() keeps filtered
     *          to the selections-letter kind only.
     */
    hasSelectionDocument() {
        const self = this;

        return !!(self.documents && self.documents.length);
    }

    prepareSelectionSettings() {
        const self = this;

        self.selection_settings = self.property.settings.find(x => x.name === self.PROPERTY_SETTINGS_SELECTIONS);

        if (self.selection_settings && self.selection_settings.value) {
            self.selection_settings = JSON.parse(self.selection_settings.value);

            // Parse string values to integer
            self.parseSelectionSettingFromStringToInteger();

            self.expiry_date_picker = self.selection_settings.expiry_date
                ? self.SSUtilService.formatDateDMY(self.selection_settings.expiry_date)
                : null;
        } else {
            self.expiry_date_picker = null;
            self.selection_settings = {
                enable: 0,
                enable_auto_selection_after_expiry: 0,
                time_limit: null,
                expiry_date: null,
                enable_reselection_in_reissue: 0
            };
        }
    }

    saveSelectionSetting() {
        const self = this;

        if (!self.verifySelectionSetting()) {
            self.SSAlertService.danger("Error.", "Please enter required fields to proceed.");
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {
                self._saveSelectionSetting();
            }
        );
    }

    _saveSelectionSetting() {
        const self = this;

        if (self.expiry_date_picker != '' && self.expiry_date_picker != null) {
            self.selection_settings.expiry_date = self.SSUtilService.formatDateToStoreWithUtc12(self.expiry_date_picker);
        }
        
        let url = 'sec/developer/properties/' + self.property.id + '/settings';
        let params = {
            name: self.PROPERTY_SETTINGS_SELECTIONS,
            value: JSON.stringify(self.selection_settings),
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Selection setting updated successfully.");
        });
    }

    prepareUploadSelectionPDFSelection(files) {
        const self = this;

        if (!files || files.length < 1) return;
        
        self.file = files[0];

        if (self.update_selection_id) {
            self.uploadSelectionPDFSelection();
        } else {
            self.is_upload = true;
        }
        
    }

    uploadSelectionPDFSelection(callback) {
        const self = this;

        let policyUrl = 'sec/developer/properties/' + self.property_id + '/selections/' + self.update_selection_id + '/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(self.file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {                
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.file_uri = response.config.data.key;

            if (callback) {
                callback(self);
            }
        });
    }

    removeSelectionPDFSelection() {
        const self = this;

        self.file_uri = null;
        self.is_upload = false;
    }

    verifySelectionSetting() {
        const self = this;

        let valid = true;
        self.selection_settings_error = {};

        self.parseSelectionSettingFromStringToInteger();

        if (self.selection_settings.enable) {
            if (self.selection_settings.enable_auto_selection_after_expiry === 1) {
                if (!self.selection_settings.time_limit) {
                    self.selection_settings_error.time_limit = "Time Limit is mandatory.";
                    valid = false;
                }

                if (!self.expiry_date_picker) {
                    self.selection_settings_error.expiry_date_picker = "Expiry date is mandatory.";
                    valid = false;
                }
            }

            if (self.selection_settings.pre_expiry_notification) {
                if (self.selection_settings.pre_expiry_notification.enable) {
                    if (!self.selection_settings.pre_expiry_notification.days) {
                        self.selection_settings_error.pre_expiry_notification_days = "Days is mandatory.";
                        valid = false;
                    } else if (self.selection_settings.pre_expiry_notification.days < 1 || self.selection_settings.pre_expiry_notification.days > 30) {
                        self.selection_settings_error.pre_expiry_notification_days = "Days must be between 1 to 30.";
                        valid = false;
                    }
                }
            }
        }

        return valid;
    }

    parseSelectionSettingFromStringToInteger() {
        const self = this;

        // Parse string values to integer
        self.selection_settings.enable = self.selection_settings.enable ? parseInt(self.selection_settings.enable) : 0;
        self.selection_settings.enable_auto_selection_after_expiry = self.selection_settings.enable_auto_selection_after_expiry ? parseInt(self.selection_settings.enable_auto_selection_after_expiry) : null;
        self.selection_settings.time_limit = self.selection_settings.time_limit ? parseInt(self.selection_settings.time_limit) : null;
        self.selection_settings.enable_reselection_in_reissue = self.selection_settings.enable_reselection_in_reissue ? parseInt(self.selection_settings.enable_reselection_in_reissue) : 0;
        self.selection_settings.required_during_booking = self.selection_settings.required_during_booking ? parseInt(self.selection_settings.required_during_booking) : 0;
        if (self.selection_settings.enable) {
            if (self.selection_settings.pre_expiry_notification) {
                self.selection_settings.pre_expiry_notification.enable = self.selection_settings.pre_expiry_notification.enable ? parseInt(self.selection_settings.pre_expiry_notification.enable) : 0;
                self.selection_settings.pre_expiry_notification.days = self.selection_settings.pre_expiry_notification.days ? parseInt(self.selection_settings.pre_expiry_notification.days) : 0;
            }
        }
    }

    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 5,
                name: '5 Rows'
            },
            {
                id: 10,
                name: '10 Rows'
            },
            {
                id: 20,
                name: '20 Rows'
            },
            {
                id: 30,
                name: '30 Rows'
            },
            {
                id: 40,
                name: '40 Rows'
            },
            {
                id: 50,
                name: '50 Rows'
            },
            {
                id: 100,
                name: '100 Rows'
            },
            {
                id: 200,
                name: '200 Rows'
            },
            {
                id: 400,
                name: '400 Rows'
            }
        ];
    }

    setTotalPagesOptions(TOTAL_PAGES){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < TOTAL_PAGES; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString() });
        }
    }

    formatUnitData(unit) {
        const self = this;

        unit.formatted_unit_no = self.SSUtilService.getFullUnitNumber(unit);

        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_type = self.SSConfigService.getUnitTypeName(unit.type);
        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_status = self.SSConfigService.getUnitStatusName(unit.status);
        unit.formatted_price_type = self.SSConfigService.getUnitPriceTypeName(unit.price_type);
        unit.formatted_floor_plan_type = unit.floor_plan ? unit.floor_plan : '';
        unit.formatted_floor_plan_type = self.searchArray(self.floorPlans, unit.floor_plan_id);
        unit.actual_price = unit.price;

        let stack = self.findStack(unit.stack_id);
        if (stack) {
            unit.block_no = stack.block_no;
            unit.stack_name = stack.name;
        }

        // By default set the 'checked' status to false
        unit.checked = false;

        return unit;
    }

    searchArray(array, id) {
        const self = this;

        if (!array || !id) return '';

        if (typeof array == "string") {
            array = self.serverConfig[array];
        }
        let object = null;
        jQuery.each(array, function(i, e) {
            if (e.id == id) {
                object = e;
            }
        });

        return object ? object.name : '';
    }

    findStack(stackId) {
        const self = this;

        let stack = null;

        jQuery.each(self.stacks, function (i, _stack) {
            if (stackId == _stack.id) {
                stack = _stack;
                return false;
            }
        });

        return stack;
    }

    applySearch(){
        const self = this;

        var units = self.unitsBackup;

        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
        }

        self.filtered_units = angular.copy(units);

        self.loadUnits(undefined, units);
        // Re-Assign CheckAll filter
        //self.toggleCheckAll();
    }

    isSearchApplied(){
        const self = this;

        if(!self.block_no_search && !self.unit_no_search && !(self.category_type && self.category_type.length > 0) && !(self.floor_plan_type && self.floor_plan_type.length > 0)
            && !self.name_search && !self.price_type_search && !self.price_search && !self.psf_search && !self.status_search){

            return false;
        }
        else{
            return true;
        }
    }

    getFilteredUnits(){
        const self = this;

        let units = [];

        if (self.block_no_search) {
            units = self.unitsBackup.filter(x => x.block_no.toString().indexOf(self.block_no_search.trim()) > -1);
        }

        if (self.unit_no_search) {
            if (units.length > 0) {
                units = units.filter(x => x.named_id.toString().indexOf(self.unit_no_search.trim()) > -1);
            } else {
                units = self.unitsBackup.filter(x => x.named_id.toString().indexOf(self.unit_no_search.trim()) > -1);
            }
        }

        if (self.category_type && self.category_type.length > 0) {
            if (units.length > 0) {
                units = units.filter(function(item) {
                  return self.category_type.indexOf(item.category) !== -1
                });
            } else {
                units = self.unitsBackup.filter(function(item) {
                  return self.category_type.indexOf(item.category) !== -1
                });
            }
        }

        if (self.floor_plan_type && self.floor_plan_type.length > 0) {
            if (units.length > 0) {
                units = units.filter(function(item) {
                  return self.floor_plan_type.indexOf(item.floor_plan_id) !== -1
                });
            } else {
                units = self.unitsBackup.filter(function(item) {
                  return self.floor_plan_type.indexOf(item.floor_plan_id) !== -1
                });
            }
        }

        if (self.name_search) {
            if (units.length > 0) {
                units = units.filter(x => x.name.toLowerCase().indexOf(self.name_search.toLowerCase().trim()) > -1);
            } else {
                units = self.unitsBackup.filter(x => x.name.toLowerCase().indexOf(self.name_search.toLowerCase().trim()) > -1);
            }
        }

        if (self.status_search) {
            if (units.length > 0) {
                units = units.filter(x => x.status == self.status_search);
            } else {
                units = self.unitsBackup.filter(x => x.status == self.status_search);
            }
        }

        return units;
    }

    toggleCheckAll(){
        const self = this;

        self.checked = 0;
        // Uncheck all to apply new changes
        jQuery.each(self.unitsBackup, function (index, unit) {
            self.checkboxes.items[unit.id] = false;
        });

        self.edited_status = "";

        let units = self.unitsBackup;

        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
        }

        if(self.checkAll){
            // All units checked
            jQuery.each(units, function (index, unit) {
                self.checkboxes.items[unit.id] = true;
                self.checked += 1;
            });
            self.edited_status = "Changes will be applied to " + self.checked + " rows";
        }
        self.checkboxes.count = self.checked;
    }

    updateCount(is_check) {
        const self = this;

        is_check ? self.checkboxes.count++ : self.checkboxes.count--;
    }

    resetUnitSelector() {
        const self = this;

        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };

        self.checkAll = false;
        self.show_top_filter = false;
        self.block_no_search = "";
        self.unit_no_search = "";
        self.category_search = "";
        self.floor_plan_type = [];
        self.name_search = "";
        self.status_search = "";
    }

    updateUnitCheckboxes() {
        const self = this;

        if (self.edit_selection.units && self.edit_selection.units.length > 0) {
            //Loop all units and apply checkbox
            $.each(self.edit_selection.units, function(index, unit_id) {
                self.checkboxes.items[unit_id] = true;
            });
            // units_master
        } else {
            self.toggleCheckAll();
        }
        
    }

    prepareUpdateSelectionUnits() {
        const self = this;

        let units = "";

        if (self.checkboxes.items) {
            var filteredUnits = Object.keys(self.checkboxes.items).reduce((p, c) => {    
              if (self.checkboxes.items[c]) p[c] = self.checkboxes.items[c];
              return p;
            }, {});

            units = Object.keys(filteredUnits).join(",");
        }

        return units;
    }

    addSelectionChoice() {
        const self = this;

        let choice = {};

        if (!self.selection_choices) {
            self.selection_choices = [];
        }

        self.selection_choices.push(choice);

        self.$timeout(function () {
            $("select.eoi-select[id^=document_type]").niceSelect('update');
        });
    }

    removeSelectionChoice(index) {
        const self = this;

        if (index > -1) {
          self.selection_choices.splice(index, 1);
        }
    }

    update_is_with_price() {
        const self = this;

        if (self.is_with_price) {
            self.setSelectionTypeValuesOnlyCheckboxAndRadio();
        } else {
            self.setSelectionTypeValuesAll();
        }
    }

    updateSelectionTypeFilter(){
        const self = this;

        self.$timeout(function () {
            $("select.eoi-select[id^=document_type]").niceSelect('update');
        });
    }

    getPhaseIndicatorLabel(phase){
        const self = this;
        if(!phase) return '--';
        return self.propertySelectionPhaseIndicators.find(phaseIndicatorObject => phaseIndicatorObject.id === phase).name;
    }
    exportSelections() {
        const self = this;
        let url = 'sec/developer/properties/' + self.property.id + '/property-selections-export';
        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href  = url;
        self.SSAlertService.success('Selections exported successfully.');
    }


    //######

    /**
     * Entry point of the Selection Import flow.
     *
     * Blocks the import until a Selection Document exists under the project's
     * property documents. The documents are re-fetched first so the check runs
     * against the latest server state (the document may have been created in
     * another tab after this screen was loaded).
     *
     * @returns {void}
     */
    importSelections() {
        const self = this;

        if (!self.importParams.selectionExcelFile) {
            self.SSAlertService.warning('Please select file to import.');
            return;
        }

        self.getPropertyDocuments(function () {

            if (!self.hasSelectionDocument()) {
                self.SSAlertService.danger('Error.', 'Selection document has not been created yet. Please create the selection document before importing.');
                return;
            }

            self.OTPService.getVerified(
                self.OTPService.TYPE_SESSION_2FA,
                function () {
                    self.parseSelectionExcel(self.importParams.selectionExcelFile);
                }
            );
        });
    }


    parseSelectionExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/import/property-selections/parse'),
            method: 'POST',
            data: {
                import_file: file
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);

            self.progressUploadingFiles = false;
            self.filesUploadProgress = 100;

            response = response.data ? response.data : {};

            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.importData = response.data;
            console.log(self.importData);
            console.log(self.importParams.selectionAssetFiles);

            if (self.importParams.selectionAssetFiles && self.importParams.selectionAssetFiles.length) {
                self.uploadSelectionsFiles();
            } else {
                self._importSelections();
            }

        }, function (response) {
            loading(false);

            self.progressUploadingFiles = false;
            self.SSAlertService.parseAndDisplayError(response);

        }, function (evt) {
        });
    }

    uploadSelectionsFiles() {
        const self = this;

        if (!self.importParams.selectionAssetFiles)
            return;

        console.log(self.importParams.selectionAssetFiles);
        self.processedFiles = 0;
        self.totalFiles = self.importParams.selectionAssetFiles.length;
        let policyUrl = 'sec/developer/properties/' + self.property.id + '/selections/s3-policy-document';


        self.assets = {};
        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policy) {
            loading(false);

            self._uploadFile(policy);
        });
    }

    _uploadFile(policy, file, retryCount) {
        const self = this;

        if (!file) {
            file = self.importParams.selectionAssetFiles.pop();
        }
        if (!retryCount) {
            retryCount = 0;
        }

        self.currentFileName = file.name;

        self.SSAwsService.upload(file, policy, function (response) {

            if (response instanceof Error) {
                if (retryCount < 2) {
                    // Retry
                    self._uploadFile(policy, file, retryCount + 1);
                    return;
                }

                self.SSAlertService.parseAndDisplayError(response);
            } else {
                self.SSAlertService.success('Success!', 'Assets uploaded successfully.');

                self.assets[response.config.data.file.name] = response.config.data.key;
                self.processedFiles += 1;

                self.filesUploadProgress = parseInt(100.0 * self.processedFiles / self.totalFiles);

                if (self.processedFiles == self.totalFiles) {
                    self._importSelections();
                } else {
                    self._uploadFile(policy);
                }
            }
        });
    }

    _importSelections() {
        const self = this;

        let importUrl = 'sec/developer/import/property-selections';

        let params = {
            property_id: self.property.id,
            property_selections: self.importData.property_selections,
            assets: self.assets
        };

        loading(true);
        self.SSHttpService.postAPIRequest(importUrl, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'All data is imported successfully.');

            self.progressUploadingFiles = false;

            // Update local data
            if (!self.selections) {
                self.selections = response.data.property_selections;
            } else {
                let selections = response.data.property_selections;
                jQuery.each(self.selections, function(i, selection) {
                    if (!self.SSUtilService.findValueFromArray(selections, 'name', selection.name)) {
                        selections.push(selection);
                    }
                });
                self.selections = selections;
            }
            self.showImport = false;
            self.getPropertySelections();
            self.enableSelectionsAfterImport();
        });
    }

    /**
     * Turns the project's Selections setting ON after a successful import, so the
     * imported selections are live without a further manual step. The developer can
     * still switch it off afterwards from the Selections settings card.
     *
     * The property is re-fetched first so the saved payload is built from the stored
     * settings rather than from any unsaved edits left on screen.
     *
     * @returns {void}
     */
    enableSelectionsAfterImport() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            self.prepareSelectionSettings();

            if (self.selection_settings.enable == 1) {
                // Already enabled, nothing to do.
                return;
            }

            self.selection_settings.enable = 1;

            // Property settings writes are 2FA step-up gated. The session was already
            // verified at the start of the import, so this resolves without a prompt.
            self.OTPService.getVerified(
                self.OTPService.TYPE_SESSION_2FA,
                function () {
                    self._saveSelectionSetting();
                }
            );
        });
    }
    //######
}

PropertySelectionController.$inject = ['$scope', '$window', '$cookies', '$localStorage','$sce', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSConfigService', 'SSUserService', 'OTPService', '$timeout', 'SSAwsService', 'SSAppService', 'Upload'];
app.controller('PropertySelectionController', PropertySelectionController);